import React from 'react'

export default function CustomDateFilter({ handlechange, payload, handleApply }) {
  return (
    <>
      <div className='custom-date-filter-popup'>
        <div>
          <div className='closeOption' onClick={() => handlechange("show", false)}>
            <i className='fa fa-times'></i>
          </div>
        </div>

        <div className='row' style={{ marginTop: '10px' }}>
          <div className="col-xs-12">
            <h5>Custome Date Range</h5>
          </div>
          <div className="col-sm-6 col-xs-12" style={{ marginTop: '10px' }}>
            <input className='customDateInput' type='date' value={payload?.from} onChange={(e) => handlechange("from", e.target.value)} />
          </div>
          <div className="col-sm-6 col-xs-12" style={{ marginTop: '10px' }}>
            <input className='customDateInput' type='date' value={payload?.to} onChange={(e) => handlechange("to", e.target.value)} />
          </div>
          <div className="col-xs-12" style={{ marginTop: '14px' ,textAlign:'end'}}>
            <button className='customBtn' onClick={()=>handleApply()}>Apply</button>
          </div>
        </div>
      </div>
    </>
  )
}
